import { ClassesBuilder } from '@utilities';

const classesConfig = {
  richText: 'copy',
  richTextDark: 'copy-dark',
};

export default new ClassesBuilder(classesConfig);
